import classNames from 'classnames';
import React from 'react';
import styles from './Kbd.module.scss';

export interface Props extends React.HTMLProps<HTMLElement> {
  /** Should this element show a hover effect? */
  hoverEffect?: boolean;
}

const Kbd = ({ className, hoverEffect, ...rest }: Props) => {
  return (
    <kbd
      {...rest}
      className={classNames(styles.kbd, { [styles.hoverEffect]: hoverEffect }, className)}
    />
  );
};

export default Kbd;
